<template>
    <div class="position-relative slideshow-container" id="slideshow-wrap">
        <div
            class="position-absolute w-full overflow-hidden slideshow-overlay"
            style="border-radius: 30px"
        >
            <img
                :src="currentImage"
                class="position-absolute w-full h-full slideshow-image left-0 top-0"
                alt="Demo profile screenshot"
            />
        </div>
        <img
            id="bezel"
            class="phone-frame w-72 position-relative"
            src="/template/allmyonline/assets/iphone-16-pro-frame-nonotch.png"
            alt="iPhone 16 Pro Frame"
        />
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

const props = defineProps({
    demoScreenshots: Array,
    isDigitalCard: Boolean,
});

// Hardcoded demo screenshot paths
let demoScreenshots = props.demoScreenshots || [
    "/template/allmyonline/assets/img/hp-slideshow/demo-averyanywhere.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/fashion2.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-eatsbyemi.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-framesbyfinn.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-greenhabibi.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-ilustrachica.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-inkedbyisaiah.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-investwithsofia.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-jennuinelee.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-leostyles.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-lesswithleo.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/gaming.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-marketwithmiles-1.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-onyxphysique.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-riosrenews.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-solarte.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-thesareeswirl.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/letsgo.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-tokyopaws.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-valeriaspins.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/demo-solanavoyage.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/thefashionduo.jpg",
    "/template/allmyonline/assets/img/hp-slideshow/studiokoyo.jpg",
];

if (props.isDigitalCard) {
    demoScreenshots = [
        "/template/allmyonline/digital-cards-demo/digital-card-apple.png",
        "/template/allmyonline/digital-cards-demo/contact-phone.png",
    ];
}

// Shuffle the demo screenshots array using Fisher-Yates algorithm
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

// Shuffle the screenshots
if (!props.isDigitalCard) {
    demoScreenshots = shuffleArray(demoScreenshots);
}

const currentImageIndex = ref(0);
let intervalId = null;

const currentImage = computed(() => {
    return demoScreenshots[currentImageIndex.value];
});

const nextImage = () => {
    currentImageIndex.value =
        (currentImageIndex.value + 1) % demoScreenshots.length;
};

onMounted(() => {
    if (demoScreenshots.length > 1) {
        intervalId = setInterval(nextImage, 2000);
    }
});

onBeforeUnmount(() => {
    if (intervalId) {
        clearInterval(intervalId);
    }
});
</script>

<style scoped>
#slideshow-wrap {
    display: inline-block;
}

.slideshow-container {
    opacity: 1;
    transition: all 0.3s ease-in-out;
    aspect-ratio: 16 / 33;
    margin-top: 4rem;
}

.slideshow-overlay {
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
    width: auto;
}

.slideshow-image {
    border-radius: 3.2rem;
    object-fit: cover;
    object-position: top;
    padding-top: 0.59rem;
    padding-left: 0.71rem;
    padding-right: 0.71rem;
}

.phone-frame {
    pointer-events: none;
}
@media (min-width: 769px) {
    .slideshow-container {
        margin-top: 0;
    }
}

/* Responsive width for larger screens */
@media (min-width: 992px) {
    .phone-frame {
        width: 20rem !important;
    }
}
</style>
